import {
  FormCategory,
} from 'dtos/formCategory';

const consentFormCategoryValues = new Set<string>(
  Object.values(FormCategory),
);

export default function isConsentFormCategory(
  value: string | null | undefined,
): value is FormCategory {
  return typeof value === 'string' && consentFormCategoryValues.has(value);
}
